import type { FaireProductEntity } from "../../entity_types/product";

export const p_pbgu9cddvp: FaireProductEntity = {
  token: "p_pbgu9cddvp",
  type: "product",
  name: "Cherries - Organic Cotton Jacquard Knit Baby Blanket",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/47783215818d215f4b7cd395af2cef004c866b33644312829a331b458a4fc095.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/047fbf8cdc486675b976ea43d0b4c46b84a51d618969ef21097fa238000c63c7.png",
    "https://cdn.faire.com/fastly/277a6483f4a77e3aadb29695102e9c6274eeea3f314416c571aa3e10ef3ec84e.png",
    "https://cdn.faire.com/fastly/b19b7ee5813064a48511e2a9e10acec0d383a6ae78582c422dacca0ddf801959.png",
  ],
  priceDollars: 26,
  description:
    "Organic Cotton Jacquard Baby Blanket – Cherries Motif\n\nInspired by the calm rhythm of the ocean, this 100% organic cotton jacquard baby blanket features a beautifully textured knit with cute cherries motifs.\n\nThe breathable jacquard construction offers a soft, lightweight, and cozy feel, making it perfect for all seasons. Gentle on delicate skin and free from harmful chemicals, it delivers natural comfort parents can trust.\n\nMade from sustainably grown organic cotton, this blanket supports better livelihoods for small grower farmers and reflects a commitment to responsible craftsmanship. Designed in the USA and ethically made by skilled artisans in India at a GOTS-certified facility, every piece is created with care and intention.\n\nIdeal for nursery decor, stroller rides, and quiet cuddle moments—this blanket brings a touch of the sea to everyday comfort.\n\nPure comfort, by Viverano.",
  tags: [],
  msrpDollars: 52,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T19:56:50.852Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
